module.exports = __webpack_public_path__ + "static/img/ewm.ba73bdf4.png";